var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "report" }, [
    _c(
      "div",
      { staticClass: "page-header-wrapper" },
      [
        _c("PageHeader", {
          attrs: { title: `${_vm.nameLabel} Activity - Department` },
        }),
        _c(
          "el-form",
          { staticClass: "filter-wrapper", attrs: { "label-width": "60px" } },
          [
            _c(
              "el-col",
              {
                directives: [
                  {
                    name: "role",
                    rawName: "v-role",
                    value: [1],
                    expression: "[1]",
                  },
                ],
                attrs: { span: 6 },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Role", prop: "role" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select Role",
                          filterable: "",
                        },
                        on: { change: _vm.roleChange },
                        model: {
                          value: _vm.form.role,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "role", $$v)
                          },
                          expression: "form.role",
                        },
                      },
                      _vm._l(_vm.roleOptions, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.name, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              {
                directives: [
                  {
                    name: "role",
                    rawName: "v-role",
                    value: [1],
                    expression: "[1]",
                  },
                ],
                attrs: { span: 6 },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Leader", prop: "taId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select Leader",
                          filterable: "",
                        },
                        on: { change: _vm.taChange },
                        model: {
                          value: _vm.form.taId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taId", $$v)
                          },
                          expression: "form.taId",
                        },
                      },
                      _vm._l(_vm.taOptions, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.TAName, value: item.TAID },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.filterSpan } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Team", "label-width": "55px" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Please select Team",
                          filterable: "",
                        },
                        model: {
                          value: _vm.form.teamId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "teamId", $$v)
                          },
                          expression: "form.teamId",
                        },
                      },
                      _vm._l(_vm.teamOptions, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.TeamName, value: item.TeamID },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.filterSpan } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Year" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "Please select year" },
                        model: {
                          value: _vm.form.year,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "year", $$v)
                          },
                          expression: "form.year",
                        },
                      },
                      _vm._l(_vm.yearsOptions, function (item) {
                        return _c("el-option", {
                          key: item.Year,
                          attrs: { label: item.Year, value: item.Year },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.filterSpan } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Month" } },
                  [
                    _c(
                      "el-select",
                      {
                        directives: [
                          { name: "multiple-tip", rawName: "v-multiple-tip" },
                        ],
                        ref: "monthSelect",
                        staticClass: "month-select",
                        attrs: {
                          placeholder: "Please select month",
                          multiple: "",
                        },
                        on: { change: _vm.monthSelectChange },
                        model: {
                          value: _vm.form.month,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "month", $$v)
                          },
                          expression: "form.month",
                        },
                      },
                      _vm._l(_vm.monthOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.filterSpan } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Type", prop: "type" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "Please select type" },
                        model: {
                          value: _vm.form.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "type", $$v)
                          },
                          expression: "form.type",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "All", value: "" } }),
                        _c("el-option", {
                          attrs: {
                            label: "Content Push / Meeting Push",
                            value: "ContentMeetingPush",
                          },
                        }),
                        _c("el-option", {
                          attrs: { label: "Quick Push", value: "QuickPush" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "query-action" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      disabled: _vm.queryable,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.getTableData()
                      },
                    },
                  },
                  [_vm._v(" Query ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "iconfont icon-export",
                      disabled: _vm.exportable,
                      loading: _vm.exporting,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.getTableData(true)
                      },
                    },
                  },
                  [_vm._v(" Export ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "role",
            rawName: "v-role",
            value: [2, 6, 8, 10, 12],
            expression: "[2, 6, 8, 10, 12]",
          },
        ],
        ref: "charts",
        staticClass: "charts",
      },
      [
        _c("div", { staticClass: "chart-row" }, [
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("h4", [_vm._v("No. Of Push / Hits / Comments")]),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.noOfPushHitsCommentsChartDataEmpty,
                  expression: "!noOfPushHitsCommentsChartDataEmpty",
                },
              ],
              ref: "noOfPushHitsCommentsChart",
              staticClass: "chart",
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.noOfPushHitsCommentsChartDataEmpty,
                    expression: "noOfPushHitsCommentsChartDataEmpty",
                  },
                ],
                staticClass: "chart empty",
              },
              [_c("span", [_vm._v("No Data")])]
            ),
          ]),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("h4", [_vm._v("Interaction")]),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.interactionChartDataEmpty,
                  expression: "!interactionChartDataEmpty",
                },
              ],
              ref: "interactionChart",
              staticClass: "chart",
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.interactionChartDataEmpty,
                    expression: "interactionChartDataEmpty",
                  },
                ],
                staticClass: "chart empty",
              },
              [_c("span", [_vm._v("No Data")])]
            ),
          ]),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("h4", [_vm._v("Avg. Duration(s)")]),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.avgPageviewsChartDataEmpty,
                  expression: "!avgPageviewsChartDataEmpty",
                },
              ],
              ref: "avgPageviewsChart",
              staticClass: "chart",
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.avgPageviewsChartDataEmpty,
                    expression: "avgPageviewsChartDataEmpty",
                  },
                ],
                staticClass: "chart empty",
              },
              [_c("span", [_vm._v("No Data")])]
            ),
          ]),
        ]),
      ]
    ),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            attrs: {
              data: _vm.tableData,
              "element-loading-text": "Loading...",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "Department", label: "Department", width: "125" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "NoOfPush",
                label: "No. Of Push",
                "min-width": "105",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "NoOfHits",
                label: "No. Of Hits",
                "min-width": "115",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "NoOfComments",
                label: "No. Of Comments",
                "min-width": "140",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "115",
                prop: "Interactions",
                label: "Interaction",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "150",
                prop: "AvgPageView",
                label: "Avg. Duration(s)",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }